// Same hover as the top-nav dropdowns, in both themes: a 4px background
// pill, the heading in its normal colour, and the icon chip carrying the
// product accent - brand pink on the Database docs, brand purple on Agent
// Memory. The light declarations repeat because the `light` mixin compiles
// to a `:root[...]` prefix that outranks unscoped state rules.
.menu-item {
	border-radius: 0;
	transition: background-color .15s ease;

	&:hover,
	&[data-hovered] {
		background-color: var(--docs-card-hover);

		@include light {
			background-color: var(--surreal-surface-light);
		}

		:global(.mantine-ThemeIcon-root) {
			background: var(--docs-accent);
			color: var(--docs-accent-contrast);

			@include light {
				background: var(--docs-accent);
				color: var(--docs-accent-contrast);
				border-color: transparent;
			}

			svg {
				color: var(--docs-accent-contrast) !important;
			}
		}
	}
}

// Copy button, split into a label and a chevron compartment by a hairline -
// the shape the reference docs use - rather than one pill with the chevron
// floating inside it.
.copy-button {
	padding-inline: var(--mantine-spacing-sm) 0;

	:global(.mantine-Button-section[data-position="right"]) {
		margin-left: var(--mantine-spacing-sm);
		padding-inline: var(--mantine-spacing-sm);
		align-self: stretch;
		display: flex;
		align-items: center;
		border-left: 1px solid var(--surreal-border-strong);
	}
}
